import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { NotetakerToggleIcon } from './notetaker_toggle_icon';
const notetakerToggleContainerCss = "n10rdhyf";
const notetakerToggleInfoCss = "n17eze23";
const notetakerToggleDescriptionCss = "n14vxd6u";
const notetakerToggleButtonCss = "n1phu70g";
const notetakerToggleButtonOnCss = "nxf9364";
const notetakerToggleButtonOffCss = "nw8vmqk";
const notetakerToggleLabelCss = "nku5yfe";
const notetakerToggleLabelOnCss = "n1wokdhs";
const notetakerToggleLabelOffCss = "nkedgxl";
const notetakerIconWrapperCss = "nrqg5vv";
const notetakerIconWrapperOnCss = "n1wr5oox";
const notetakerIconWrapperOffCss = "n13m5u3i";
const notetakerIconCss = "nehlxh3";
const getNotetakerLocationLabel = kind => {
  if (kind === 'zoom_conference') {
    return I18n.t('publisher.event_type_editor.sections.event_details.location.dropdown.zoom_conference.label');
  }
  if (kind === 'google_conference') {
    return I18n.t('publisher.event_type_editor.sections.event_details.location.dropdown.google_conference.label');
  }
  if (kind === 'microsoft_teams_conference') {
    return I18n.t('publisher.event_type_editor.sections.event_details.location.dropdown.microsoft_teams_conference.label');
  }
  return '';
};
export const NotetakerToggle = ({
  isEnabled,
  isDisabled,
  locationKind,
  onToggle
}) => {
  const locationName = getNotetakerLocationLabel(locationKind);
  const description = I18n.t('publisher.event_type_editor.sections.event_details.location.notetaker_toggle.description', {
    location_name: locationName
  });
  return <div className={notetakerToggleContainerCss} data-testid="notetaker-toggle">
      <div className={notetakerToggleInfoCss}>
        <BodyText size="medium" weight="bold">
          {I18n.t('publisher.event_type_editor.sections.event_details.location.notetaker_toggle.title')}
        </BodyText>
        <BodyText size="medium" className={notetakerToggleDescriptionCss}>
          {description}
        </BodyText>
      </div>
      <BareButton type="button" role="switch" aria-checked={isEnabled} aria-label={I18n.t('publisher.event_type_editor.sections.event_details.location.notetaker_toggle.title')} className={classNames(notetakerToggleButtonCss, isEnabled ? notetakerToggleButtonOnCss : notetakerToggleButtonOffCss)} disabled={isDisabled} onClick={isDisabled ? undefined : onToggle}>
        <BodyText size="small" weight="bold" className={classNames(notetakerToggleLabelCss, isEnabled ? notetakerToggleLabelOnCss : notetakerToggleLabelOffCss)}>
          {isEnabled ? I18n.t('publisher.action.on') : I18n.t('publisher.action.off')}
        </BodyText>
        <span className={classNames(notetakerIconWrapperCss, isEnabled ? notetakerIconWrapperOnCss : notetakerIconWrapperOffCss)}>
          <NotetakerToggleIcon className={notetakerIconCss} />
        </span>
      </BareButton>
    </div>;
};

require("./notetaker_toggle.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./notetaker_toggle.js");